<template>
    <el-header>
        <el-row>
            <el-col class="header-index">
                <span class="title">{{ title }}</span>
                <div class="pull-right">
                    <el-tooltip v-for="action in actions" :content="action.title" placement="top" :key="action.title">
                        <i :class="action.icon" class="clickable" @click="action.onClick"></i>
                    </el-tooltip>
                </div>
            </el-col>
        </el-row>
        <hr/>
    </el-header>

</template>

<script>
    export default {
        name: "PageHeader",
        props: {
            title: {
                required: true
            },
            actions: {
                default: []
            }
        }
    }
</script>

<style scoped>
.title{
  font-size: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/PageHeader.vue